module.exports = __webpack_public_path__ + "boxed-bg.7799dece2c79854f63f0.jpg";


//////////////////
// WEBPACK FOOTER
// C:/Users/RvlxAdmin/Desktop/Sayali-Shupple-Code/Shupple-admin/~/admin-lte/dist/img/boxed-bg.jpg
// module id = ../../../../admin-lte/dist/img/boxed-bg.jpg
// module chunks = 2